<script setup lang="ts">
/**
 * Aura AGM (AUDITED · Multiple member) — AGM Documents. 템플릿 docx 를 그대로 재현.
 *   1 DRW(Audited) · 2 Notice of AGM(Audited, 감사인 재선임) · 3 Consent to Short Notice(members) ·
 *   4 Minutes of AGM(Chairman, 감사인 재선임) · 5 Attendance List.
 *   (agm-multi(Unaudited)와 달리 Small Company/Solvency 없음 — audited 는 감사면제 대상 아님.)
 * cdd/서명 컴포넌트는 형제 `agm` 모듈 재사용. 이사 서명 = agm_Signers([[Signers]]), 멤버 서명 = members 루프, 의장 = chairman_name.
 */
import CddVarField from '../../agm/cdd/CddVarField.vue';
import AgmSigners from '../../agm/cdd/AgmSigners.vue';
import AgmMemberSigners from './AgmMemberSigners.vue';
import '../../agm/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <!-- ════ 1. DIRECTORS' RESOLUTIONS IN WRITING (Audited) ════ -->
    <div class="doc-head" style="text-align:center">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">DIRECTORS&rsquo; RESOLUTIONS IN WRITING</div>
    <div class="doc-sub">PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">AUDITED FINANCIAL STATEMENTS</div>
    <p class="doc-p">Resolved that the audited financial statements of the Company for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> together with the directors&rsquo; statement and
      Independent Auditor&rsquo;s Report thereon be approved and that the said directors&rsquo; statement be signed by any two
      directors of the Company on behalf of the board of directors.</p>

    <div class="sec-title">SPECIAL BUSINESS FOR ANNUAL GENERAL MEETING</div>
    <p class="doc-p">Resolved that in addition to the ordinary business of the Annual General Meeting, the following resolutions
      be proposed, by way of a special business, for adoption at the Annual General Meeting.</p>
    <p class="doc-p center"><b>ORDINARY RESOLUTIONS</b></p>
    <p class="doc-p center"><b>DIRECTORS&rsquo; FEE AND/OR DIRECTORS&rsquo; REMUNERATION</b></p>
    <p class="doc-p">That the Directors&rsquo; Fee and/or Directors&rsquo; Remuneration, if any, for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" />, as stated in the financial statements be and
      are hereby approved.</p>

    <div class="sec-title">ANNUAL GENERAL MEETING</div>
    <p class="doc-p">Resolved that any director be authorised to make the necessary arrangements to convene the Annual General
      Meeting of the Company.</p>

    <div class="sec-title">AUTHORITY TO E-FILE RETURNS</div>
    <p class="doc-p">Resolved that any officer of the Company or such other person(s) as directed by the directors be authorised
      to e-file the relevant returns relating thereto with the Accounting and Corporate Regulatory Authority, for and on behalf
      of the Company.</p>
    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>

    <div class="sec-title">DIRECTORS / SIGNATURES</div>
    <AgmSigners var-key="agm_Signers" board-label="Directors" />

    <!-- ════ 2. NOTICE OF ANNUAL GENERAL MEETING (Audited) ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <p class="doc-p">Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></p>
    <div class="doc-title">NOTICE OF ANNUAL GENERAL MEETING</div>
    <p class="doc-p">NOTICE IS HEREBY GIVEN that the Annual General Meeting of the Company will be held at:</p>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>
    <div class="sec-title">AGENDA</div>
    <p class="doc-p">To receive and adopt the audited financial statements of the Company for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> together with the directors&rsquo; statement and
      Independent Auditor&rsquo;s Report thereon.</p>
    <p class="doc-p">To re-elect retiring director.</p>
    <p class="doc-p">To re-appoint auditor and fix their remuneration.</p>
    <p class="doc-p">As special business to propose, and if thought fit, to pass the following ordinary resolutions:-</p>
    <p class="doc-p center"><b>Ordinary Resolutions</b></p>
    <p class="doc-p center"><b>Directors&rsquo; Fee and/or Directors&rsquo; Remuneration</b></p>
    <p class="doc-p">That the Directors&rsquo; Fee and/or Directors&rsquo; Remuneration, if any, for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" />, as stated in the financial statements be and is hereby approved.</p>
    <p class="doc-p">To transact any other business which may properly be transacted at an Annual General Meeting.</p>
    <p class="doc-p">By Order Of The Board</p>
    <AgmSigners var-key="agm_Signers" board-label="Director" />
    <p class="doc-p">Date: <CddVarField field-key="notice_date" label="Notice Date" /></p>
    <div class="doc-note">
      Notes:<br />
      1. A member entitled to attend and vote at the above meeting is entitled to appoint a proxy to attend and vote instead of him. A proxy need not be a member of the Company.<br />
      2. A corporation which is a member of the Company may, by resolution of its directors, authorise any person to act as its representative at any meetings of the Company, and such representative shall be entitled to exercise the same powers on behalf of the corporation which he represents as if he had been an individual member of the Company.<br />
      3. The instrument appointing a proxy must be deposited at the registered office of the Company not less than <CddVarField field-key="proxy_cut_off" label="Proxy Cut-off (hours)" /> hours before the meeting.
    </div>

    <!-- ════ 3. CONSENT TO SHORT NOTICE — MEMBERS ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">CONSENT TO SHORT NOTICE OF THE ANNUAL GENERAL MEETING</div>
    <p class="doc-p">We, the undersigned, being all the members of the Company entitled to attend and vote at the Annual General
      Meeting (&ldquo;AGM&rdquo;) of the Company hereby agree for the below AGM of the Company to be held notwithstanding that it is
      called by notice shorter than that which is required by the Companies Act 1967 of Singapore and the Constitution of the Company.</p>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>
    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>
    <div class="sec-title">MEMBERS / SIGNATURES</div>
    <AgmMemberSigners board-label="Members" />

    <!-- ════ 4. MINUTES OF ANNUAL GENERAL MEETING (Chairman) ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">MINUTES OF ANNUAL GENERAL MEETING</div>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
        <tr><td class="cdd-lcell">Present</td><td>:&nbsp; As per Attendance List</td></tr>
      </tbody>
    </table>
    <div class="sec-title">CHAIRMAN</div>
    <p class="doc-p"><CddVarField field-key="chairman_name" label="Chairman" /> was elected chairman of the meeting.</p>
    <div class="sec-title">NOTICE OF MEETING</div>
    <p class="doc-p">Notice of the meeting was taken as read.</p>
    <div class="sec-title">AUDITED FINANCIAL STATEMENTS</div>
    <p class="doc-p">It was resolved that the audited financial statements of the Company for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> together with the directors&rsquo; statement and
      Independent Auditor&rsquo;s Report thereon be received and adopted.</p>
    <div class="sec-title">SPECIAL BUSINESS &mdash; ORDINARY RESOLUTIONS</div>
    <p class="doc-p center"><b>DIRECTORS&rsquo; FEE AND/OR DIRECTORS&rsquo; REMUNERATION</b></p>
    <p class="doc-p">It was resolved that the Directors&rsquo; Fee and/or Directors&rsquo; Remuneration, if any, for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" />, as stated in the financial statements be and are hereby approved.</p>
    <div class="sec-title">RETIREMENT OF DIRECTOR</div>
    <p class="doc-p">It was resolved that all the Directors who retire in accordance with the Company&rsquo;s Constitution were
      re-elected as Directors of the Company.</p>
    <div class="sec-title">AUDITORS</div>
    <p class="doc-p">It was resolved that <CddVarField field-key="auditors_name" label="Auditors Name" /> be and are hereby re-appointed
      auditors of the Company to hold office until the conclusion of the next Annual General Meeting at a remuneration to be fixed
      by the directors of the Company.</p>
    <div class="sec-title">CONCLUSION</div>
    <p class="doc-p">There being no other business, the meeting ended with a vote of thanks to the chairman.</p>
    <p class="doc-p">Confirmed by,</p>
    <div class="sign-block"><div class="sign-line"><CddVarField field-key="chairman_name" label="Chairman" /><br />Chairman of the meeting</div></div>

    <!-- ════ 5. ATTENDANCE LIST — MEMBERS ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">ATTENDANCE LIST OF ANNUAL GENERAL MEETING</div>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>
    <div class="sec-title">MEMBERS / SIGNATURES</div>
    <AgmMemberSigners board-label="Members" />
  </div>
</template>
